<template>
  <div>
    {{ $t(text) }}
  </div>
</template>

<script>
export default {
  name: "SectionUnderDevelopment",
  props: {
    text: {
      type: String,
      default: "Proximamente"
    }
  }
}
</script>